"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ForgeYourInfluence() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="7064" id="our-expertise" ref={sectionRef} className="dark bg-background text-foreground min-h-screen flex flex-col lg:flex-row overflow-hidden relative font-sans">
      {}
      <div className="w-full lg:w-1/2 relative h-[60vh] lg:h-auto bg-muted/5 overflow-hidden">
        {}
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600169/img/rpg_expertise_visual.png" alt="RPG-Studios tech-driven expertise" className="absolute inset-0 w-full h-full object-contain p-8 lg:p-12 grayscale contrast-125 brightness-75" />
        
        {}
        <div className="absolute inset-0 opacity-30 pointer-events-none mix-blend-overlay" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='1'/%3E%3C/svg%3E")`
      }} />
        
        {}
        <div className="absolute inset-0 bg-gradient-to-t from-background via-primary/10 to-transparent lg:bg-gradient-to-r lg:from-transparent lg:to-background/90 opacity-70" />
      </div>

      {}
      <div className="w-full lg:w-1/2 flex flex-col justify-center px-6 py-16 lg:p-24 relative z-10 bg-background">
        <div className="flex flex-col h-full justify-center max-w-2xl mx-auto lg:mx-0">
          
          {}
          <div className={`flex flex-col gap-0 mb-10 transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
            {['STRATEGY', 'RELATIONSHIP', 'RESULTS'].map((word, i) => <span key={word} data-index={i} className="text-5xl md:text-7xl lg:text-8xl font-black tracking-tighter text-transparent uppercase leading-[0.85] select-none font-serif" style={{
            WebkitTextStroke: '1px var(--color-primary)',
            opacity: 0.15 + i * 0.1
          }}>
                {word}
              </span>)}
          </div>

          {}
          <div className={`space-y-8 transition-all duration-1000 delay-300 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-[1.1] font-serif">
              Our Digital <br />
              <span className="text-primary bg-clip-text text-transparent bg-gradient-to-r from-primary to-chart-2">Expertise</span>
            </h2>
            
            <p className="text-muted-foreground text-lg md:text-xl max-w-md border-l-2 border-primary/50 pl-6 py-1 font-sans">
              We combine data-driven strategies with a relationship-first approach to scale your digital presence with precision and purpose.
            </p>

            {}
            <div className="pt-4">
              <Button asChild size="lg" className="bg-gradient-to-r from-primary to-chart-2 text-primary-foreground hover:opacity-90 text-lg px-10 h-14 rounded-md shadow-[0_0_30px_-5px_hsla(180,70%,50%,0.4)] transition-transform hover:scale-105 border-none">
                <Link to="/ServicesPage">
                  Explore Services <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}